/* mox-draft-pdp.js — Interceptor de “Add to Cart” (solo usuarios logueados, draft-only) */
(function () {
  // Evita doble binding si el tema reinyecta secciones o scripts
  if (window.__moxPdpBound) return;
  window.__moxPdpBound = true;

  const ATC_SELECTOR = [
    '[data-add-to-cart]',
    'button[name="add"]',
    '.add-to-cart',
    '.product-form__submit',
    '.hdt-pr-atc',
    '.hdt-main-product-form [type="submit"]',
  ].join(',');

  // === Utilidades ===========================
  const toInt = (v, d = 0) => {
    const n = Number(String(v ?? '').replace(/[^\d]/g, ''));
    return Number.isFinite(n) ? n : d;
  };

  // === Listener oficial de la tabla mox- ===
  // Recibe { variantId, quantity, productId, size } desde mox-talla-table
  window.addEventListener('mox:draft:line:update:request', async (e) => {
    const { variantId, quantity } = e.detail || {};
    if (!variantId || Number.isNaN(Number(quantity))) return;

    if (!window.MOX_CUSTOMER_ID) {
      window.dispatchEvent(new CustomEvent('mox:auth:required'));
      window.openAuthModal?.('login');
      return;
    }

    try {
      if (quantity > 0) {
        if (window.MOX_DRAFT?.setQuantity) await window.MOX_DRAFT.setQuantity(variantId, quantity);
        else if (window.MOX_DRAFT?.addItem) await window.MOX_DRAFT.addItem(variantId, quantity);
      } else {
        if (window.MOX_DRAFT?.removeItem) await window.MOX_DRAFT.removeItem(variantId);
        else if (window.MOX_DRAFT?.setQuantity) await window.MOX_DRAFT.setQuantity(variantId, 0);
      }

      await window.MOX_DRAFT?.refreshLatestForCustomer?.();
      window.dispatchEvent(new CustomEvent('mox:draft:updated'));

      // Sincroniza tabla (estricto si existe; si no, fallback)
      if (window.MOX_STRICT_SYNC?.sync) {
        if (window.queueMicrotask) queueMicrotask(() => window.MOX_STRICT_SYNC.sync());
        else requestAnimationFrame(() => window.MOX_STRICT_SYNC.sync());
      } else if (window.MOX_SYNC?.syncPdpTablesFromDraft) {
        if (window.queueMicrotask) queueMicrotask(() => window.MOX_SYNC.syncPdpTablesFromDraft());
        else requestAnimationFrame(() => window.MOX_SYNC.syncPdpTablesFromDraft());
      }
    } catch (err) {
      console.error('[MOX] draft upsert error', err);
      window.dispatchEvent(new CustomEvent('mox:draft:refresh'));
    }
  });

  function readVariantAndQty(fromEl) {
    const form =
      (fromEl.closest && fromEl.closest('form')) ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form');

    const variantInput = form?.querySelector('input[name="id"], input[name="variant"], [data-variant-id]');
    const rawVariant = variantInput?.value || variantInput?.getAttribute?.('data-variant-id') || '';
    const m = String(rawVariant).match(/(\d+)$/);
    const variantIdNum = m ? m[1] : null;

    const qtyInput = form?.querySelector('input[name="quantity"], [data-qty]');
    const qty = toInt(qtyInput?.value ?? 1, 1);

    return { variantIdNum, qty: Math.max(1, qty) };
  }

  // Anti-doble disparo
  let lastHandledAt = 0;
  const HANDLE_COOLDOWN_MS = 700;
  function canHandleNow() {
    const now = Date.now();
    if (now - lastHandledAt < HANDLE_COOLDOWN_MS) return false;
    lastHandledAt = now;
    return true;
  }

  // Espera a que exista MOX_DRAFT.current o a que dispare mox:draft:loaded (con timeout)
  function waitForDraftLoaded(ms = 1500) {
    return new Promise((resolve) => {
      if (window.MOX_DRAFT?.current?.id) return resolve(window.MOX_DRAFT.current);

      let done = false;
      function finish() {
        if (done) return;
        done = true;
        window.removeEventListener('mox:draft:loaded', onLoaded);
        document.removeEventListener('mox:draft:loaded', onLoaded);
        resolve(window.MOX_DRAFT?.current || null);
      }
      function onLoaded() { finish(); }

      // (Listeners comentados a propósito en tu base estable)
      // window.addEventListener('mox:draft:loaded', onLoaded, { once: true });
      // document.addEventListener('mox:draft:loaded', onLoaded, { once: true });

      setTimeout(finish, ms);
    });
  }

  async function handleAdd(sourceEl) {
    if (!window.MOX_CUSTOMER_ID) {
      window.dispatchEvent(new CustomEvent('mox:auth:required'));
      window.openAuthModal?.('login');
      return;
    }

    const { variantIdNum, qty } = readVariantAndQty(sourceEl);
    if (!variantIdNum) {
      console.warn('[MOX] No pude obtener el variantId.');
      return;
    }

    let fired = false;
    function onLoadedOnce() {
      if (fired) return;
      fired = true;
      window.removeEventListener('mox:draft:loaded', onLoadedOnce);
      document.removeEventListener('mox:draft:loaded', onLoadedOnce);
      document.dispatchEvent(new CustomEvent('mox:shadow:open', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('mox:shadow:open'));
    }

    const draft = await window.MOX_DRAFT.addItem(variantIdNum, qty);

    const edges = draft?.lineItems?.edges;
    if (Array.isArray(edges) && edges.length && !fired) {
      onLoadedOnce();
      window.MOX_DRAFT.refreshLatestForCustomer?.().catch(() => { });
      return;
    }

    const readyDraft = await waitForDraftLoaded(1500);
    if (readyDraft?.id && !fired) {
      onLoadedOnce();
      window.MOX_DRAFT.refreshLatestForCustomer?.().catch(() => { });
      return;
    }

    if (window.MOX_DRAFT?.current && !fired) {
      onLoadedOnce();
    } else if (!fired) {
      window.bootDraftRefresh?.();
      setTimeout(() => {
        if (!fired && window.MOX_DRAFT?.current) onLoadedOnce();
      }, 800);
    }
  }

  async function handleAddInput(_qty, _variantId) {
    if (!window.MOX_CUSTOMER_ID) {
      window.dispatchEvent(new CustomEvent('mox:auth:required'));
      window.openAuthModal?.('login');
      return;
    }
    const variantIdNum = _variantId;
    const qty = _qty;

    let fired = false;
    function onLoadedOnce() {
      if (fired) return;
      fired = true;
      window.removeEventListener('mox:draft:loaded', onLoadedOnce);
      document.removeEventListener('mox:draft:loaded', onLoadedOnce);
      document.dispatchEvent(new CustomEvent('mox:shadow:open', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('mox:shadow:open'));
    }

    const draft = await window.MOX_DRAFT.addItem(variantIdNum, qty);

    const edges = draft?.lineItems?.edges;
    if (Array.isArray(edges) && edges.length && !fired) {
      onLoadedOnce();
      window.MOX_DRAFT.refreshLatestForCustomer?.().catch(() => { });
      return;
    }

    const readyDraft = await waitForDraftLoaded(1500);
    if (readyDraft?.id && !fired) {
      onLoadedOnce();
      window.MOX_DRAFT.refreshLatestForCustomer?.().catch(() => { });
      return;
    }

    if (window.MOX_DRAFT?.current && !fired) {
      onLoadedOnce();
    } else if (!fired) {
      window.bootDraftRefresh?.();
      setTimeout(() => {
        if (!fired && window.MOX_DRAFT?.current) onLoadedOnce();
      }, 800);
    }
  }

  function attachInterceptors() {
    const isLikelyPdp =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector(ATC_SELECTOR);
    if (!isLikelyPdp) return;

    document.addEventListener(
      'click',
      async (ev) => {
        const btn = ev.target.closest?.(ATC_SELECTOR);
        if (!btn) return;
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        if (!canHandleNow()) return;
        await handleAdd(btn);
      },
      true
    );

    // Submit del form (temas que disparan programáticamente)
    document.addEventListener(
      'submit',
      async (ev) => {
        const form = ev.target;
        if (!form || !form.querySelector(ATC_SELECTOR)) return;
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        if (!canHandleNow()) return;
        await handleAdd(form);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachInterceptors, { once: true });
  } else {
    attachInterceptors();
  }

  document.addEventListener('shopify:section:load', () => {
    attachInterceptors();
  });
})();

